if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();

      this.swiperInit();
      this.chromeBlurFix();

      window.addEventListener('resize', () => {
        this.chromeBlurFix();
      });
    }

    swiperInit() {
      const swiperElement = this.querySelector('[data-swiper]');

      if (!swiperElement) { return; }

      const pagination = swiperElement.querySelector('[data-swiper-pagination]');

      const swiper = new window.Swiper(swiperElement, {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: true,
        draggable: false,
        allowTouchMove: false,
        threshold: 20,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: pagination,
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },
      });

      return swiper;
    }

    chromeBlurFix() {
      const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      const heroImageBlur = this.querySelector('[data-hero-image-blur]');

      if (!isChrome || !heroImageBlur) { return; }

      heroImageBlur.style['z-index'] = 9;

      setTimeout(() => {
        heroImageBlur.style['z-index'] = 10;
      }, 1);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
}